"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Modal = exports["default"] = /*#__PURE__*/function (_Core) {
  function Modal(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Modal);
    _this = _callSuper(this, Modal, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.ready = false;
    _this.myServices = ["modal"];
    _this.init();
    return _this;
  }
  (0, _inherits2["default"])(Modal, _Core);
  return (0, _createClass2["default"])(Modal, [{
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var data, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.ready === false) {
                this.ready = true;
                this.trigger("ready", true);
                _logger["default"].success("Initialization done", "Module is now ready!", "Modal");
              }
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _t = message.action;
              _context.next = _t === 'System.SDK.ServiceNotification.Response' ? 2 : _t === 'System.ServiceNotification' ? 4 : 7;
              break;
            case 2:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
              }
              return _context.abrupt("return");
            case 4:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              // Send our data
              data = JSON.parse(message.data);
              _context.next = 6;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(data.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 6:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context.abrupt("return");
            case 7:
              return _context.abrupt("continue", 8);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "showModalDialog",
    value: function showModalDialog(modalName) {
      var _this3 = this;
      return new Promise(function (resolve) {
        var payload = {
          action: "System.ModalManager.ShowModalDialog",
          uuid: (0, _uuid.v4)(),
          requestUuid: "",
          origin: "sdk-" + _this3.appName,
          data: JSON.stringify({
            modalName: modalName
          })
        };
        _this3.connection.invoke("messaging", payload).then(function () {
          _this3.connection.on("messaging", function (msg) {
            if (msg.action === "System.ModalManager.ShowModalDialog.Response") {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Display");
      var foundServices = this.detectServices();
      if (!foundServices) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Display");
      } else {
        this.ready = true;
        this.trigger("ready", true);
        this.connection.on("messaging", this.handleMessage.bind(this));
      }
      this.connection.on("messaging", this.handleMessage.bind(this));
    }
  }]);
}(_core["default"]);